/* eslint-disable import/order */
export type ShowGameInformationIcon = boolean;

export type Group = boolean;

export type IncludeTags = string[];

export type PageSize = number;

export type Tags = boolean;

export type CasinoFormalparamcode =
  | 'tagname'
  | 'tagid'
  | 'tabletypeid'
  | '_group'
  | 'currency'
  | 'features'
  | 'gametype'
  | 'includeStats'
  | 'maxbet'
  | 'minbet'
  | 'moneyoption'
  | 'numOfLines'
  | 'platform'
  | 'playtype'
  | 'search_text'
  | 'tabletyperefname'
  | 'varianttype';

export type QueryTypes = CasinoSimpleQuery | CasinoExcludeQuery;

export type CasinoSimpleQuery = (string | number)[];

export type CasinoExcludeQuery = CasinoQueryselect[];

export type CasinoGameService =
  | 'casino.games.all.stream'
  | 'casino.games.recent.stream'
  | 'casino.games.recommended.stream'
  | 'casino.games.myfsb'
  | 'casino.games.playergames'
  | 'casino.live.games.stream'
  | '/api/v1-preview/casino/games/rapid/stream';

/**
 * Common definitions for casino objects
 */

export interface CasinoCommonObjects {
  gip?: ShowGameInformationIcon;
  grp?: Group;
  includeTags?: IncludeTags;
  psz?: PageSize;
  slide?: boolean;
  tgs?: Tags;
  hideWhenEmpty?: boolean;
  filterURL?: string;
  moreLink?: string;
  terms?: boolean;
  raceLogo?: boolean;
  mosaicLayout?: CasinoMosaicLayout;
  icon?: CasinoIcon;
  ims?: Images;
  query?: CasinoQuery;
  hideOnLogin?: boolean;
  loggedInOnly?: boolean;
  gameService?: CasinoGameService;
}

export interface CasinoMosaicLayout {
  enabled: boolean;
  section1: CasinoSection;
  section2: CasinoSection;
  section3: CasinoSection;
}

export interface Images {
  tags: CasinoIcon[];
}

export interface CasinoQuery {
  formalparamcode: CasinoFormalparamcode;
  values: QueryTypes;
  operand: CasinoOperand;
  join: CasinoJoinOperand;
  dynamic: boolean;
}

export interface CasinoQueryselect {
  formalparamcode: CasinoFormalparamcode;
  values: (string | number)[];
  operand: CasinoOperand;
  join: CasinoJoinOperand;
  dynamic: boolean;
}

export enum CasinoSection {
  OneBigSquare = '1 big square',
  FourSquares = '4 squares',
  OneTopTwoBottom = '1 top 2 bottom',
  TwoTopOneBottom = '2 top 1 bottom',
  OneTopOneBottom = '1 top 1 bottom'
}

export enum CasinoIcon {
  icnAnimated = 'icnAnimated',
  icnAnimatedHero = 'icnAnimatedHero',
  icnAnimatedHeroSquare = 'icnAnimatedHeroSquare',
  icnAnimatedHeroWide = 'icnAnimatedHeroWide',
  icnAnimatedSquare = 'icnAnimatedSquare',
  icnAnimatedWide = 'icnAnimatedWide',
  icnGameTrailerVideo = 'icnGameTrailerVideo',
  icnGameTrailerIcon = 'icnGameTrailerIcon',
  icnHero = 'icnHero',
  icnHeroSquare = 'icnHeroSquare',
  icnHeroWide = 'icnHeroWide',
  icnLive = 'icnLive',
  icnOnTable = 'icnOnTable',
  icnPoster = 'icnPoster',
  icnSquare = 'icnSquare',
  icnStandard = 'icnStandard',
  icnWide = 'icnWide',
  icnRace = 'icnRace'
}

export enum CasinoOperand {
  EQ = 1,
  NEQ = 2,
  LS = 4,
  LEQ = 8,
  GR = 16,
  GEQ = 32,
  IN = 64,
  NOT_IN = 128,
  LIKE = 256,
  NOT_LIKE = 512,
  BITAND = 1024,
  BETWEEN = 2048
}

export enum CasinoJoinOperand {
  AND = 0,
  OR = 1,
  AND_NOT = 2
}
